import { useState, useEffect, useMemo, useLayoutEffect } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useGlobalVariable } from '../../context/GlobalVariableProvider';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';

const ContraTbl = ({
    //accounts = []
    inputs={},
    requestOnRender=false,
    type=null
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
  
    // useEffect(() => {
    //     if(requestOnRender == true){
    //         //alert("requestOnRender")
    //         handleFilter(filterParams)
    //     }
        
    // }, [requestOnRender]);



  
    useEffect(() => {
        handleFilter(filterParams)

    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,1,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);
    }



    const requestTableData = async (accounts:string[],cPage=1,inputs:any={}) =>{
   
        if(accounts.length <1) {
            setTableData([])
           // return 
        }

        if(type){
            inputs['type'] = type;
        }

       // if(!orderNo)return;
        setLoading(true)
        let result = await api.getMultiAccountContra(accounts, inputs,cPage);
        setLoading(false)
      //  console.log("result ",result)
        if(result.contra){
            setTableData(result.contra)
        }else{
            setTableData([])
        }

        
        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

       //setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'datetime',
                
                rowSpan: '2',
                columns: [
                    {
                        Header: 'noneBlock1',
                        accessor: 'ctr_contradate',
                        Cell: (data: any) => {
                            if(!data.value) return;
                            return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                        },
                        displayNone: true,
                    },
                ]
            },
            {
                Header: 'Contra',
                accessor: 'ctr_contrano',
                rowSpan: '2',
                columns: [
                    {
                        Header: 'noneBlock2',
                        accessor: 'ctr_contrano',
                        displayNone: true
                    },
                ]
            },
            {
                Header: 'Due Date',
                accessor: 'delievery_date',
                rowSpan: '2',
                columns: [
                    {
                        Header: 'noneBlock3',
                        accessor: 'ctr_duedate',
                        Cell: (data: any) => {
                            if(!data.value) return;
                            return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                        },
                        displayNone: true
                    },
                ]
            },
            {
                Header: 'Stock',
                accessor: 'stock',

                columns: [
                    {
                        Header: 'Code',
                        accessor: 'ctr_stockcode',
                      },
                      {
                        Header: 'Name',
                        accessor: 'ctr_stockname',
                      },
                ],
            },
            {
                Header: 'Quantity',
                rowSpan: '2',
                accessor: 'quantity',
                columns: [
                    {
                        Header: 'noneBlock31',
                        accessor: 'ctr_quantity',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 0)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'Price',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_value',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'Currency',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'c_code_baseccy',
                        displayNone: true
                    },
                ]
            },
            {
                Header: 'Amount',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_value1',
                        displayNone: true,
                        Cell: (v: any,d:any) => {
                            let row = v.row.original;
                            return (
                                <div className="text-right">
                                    {numberWithCommas(row.ctr_value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Amount',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_os_value',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Interest',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_os_interest',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'Amount(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_value_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Amount(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_os_value_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Interest(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctr_os_interest_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
       
        ],
        []
    );

    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: 'rgba(210, 209, 209, 1)',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                pageSize={10}
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(accounts, cPage,inputs);
                }}
                hasPagination

            />
        </>
    );
};

export default ContraTbl;
